import { AuthProvider } from 'components/common/auth-provider/AuthProvider';
import { RouteScreenContext } from 'components/app/AppContext';
import { ScreenTemplate } from './ScreenTemplate';

import type { Route } from 'components/app/routes/app-routes-revamp';

type RouteScreenProps = {
  route: Route;
  routes: Route[];
  isLoginEnabled?: boolean;
};

export const RouteScreen = (props: RouteScreenProps) => {
  const { route, routes, isLoginEnabled } = props;
  const { Template: RouteTemplate, requiresLogin, noIndex } = route;
  const routeScreenContextValue = { route, routes };
  const authEnabled = requiresLogin && isLoginEnabled;
  const Template = RouteTemplate || ScreenTemplate;

  return (
    <>
      {noIndex && <meta name="robots" content="noindex" />}

      <AuthProvider enabled={authEnabled}>
        <RouteScreenContext.Provider value={routeScreenContextValue}>
          <main id="#content">
            <Template {...route} />
          </main>
        </RouteScreenContext.Provider>
      </AuthProvider>
    </>
  );
};
